<div class="vo-central-content vo-body-regular-14">
  <div class="heading-image"></div>
  <div class="login-extended-functionality-container p-0 mt-30 mx-auto text-center">
    <ng-container *ngIf="currentStep === formStep.Password">
      <div
        class="vo-heading-bold-24 mb-30 mt-60"
        [innerHTML]="referenceDataLabels.ExpiredPassword | localizeLabel | toTrustedHtml"
      ></div>
      <div
        class="vo-body-regular-14 my-30"
        [innerHTML]="referenceDataLabels.ExpiredPasswordDescription | localizeLabel | toTrustedHtml"
      ></div>

      <form #changeExpiredPasswordForm="ngForm">
        <div *ngIf="errorMessage" class="vo-body-regular-14 text-center my-30" [innerHTML]="errorMessage"></div>
        <div [ngClass]="{'has-errors': changeExpiredPasswordForm.submitted && newPasswordInput.invalid }">
          <div
            *ngIf="changeExpiredPasswordForm.submitted && newPasswordInput.invalid"
            class="error-message"
            [innerHTML]="referenceDataConstants.ERROR_MESSAGE_ME000 | localizeErrorMessage : 'NewPassword'"
          ></div>
          <boi-validation-error-generic
            class="d-block my-15"
            [validationErrors]="validationErrors"
            [propertyNames]="['PasswordToHash', 'PasswordMinimumLength', 'PasswordMissingLowerCharacter', 'PasswordMissingUpperCharacter', 'PasswordMissingSpecialCharacter', 'PasswordUsedPreviously']"
          >
          </boi-validation-error-generic>
          <boi-text-input
            class="field-input-full-width field-text-center"
            [cssClasses]="'label-top label-weight-bold'"
            [required]="true"
            name="newPassword"
            #newPasswordInput="ngModel"
            [(ngModel)]="resetPasswordDto.NewPassword"
            [labelName]="referenceDataLabels.UserResetPasswordNew"
            [canShowPassword]="true"
            [type]="'password'"
          >
          </boi-text-input>
        </div>

        <boi-password-strength
          class="password-strength__container mb-30"
          [passwordToCheck]="resetPasswordDto.NewPassword"
        >
        </boi-password-strength>

        <div
          [ngClass]="{'has-errors': changeExpiredPasswordForm.submitted && confirmedNewPasswordInput.invalid &&
    ((confirmedNewPasswordInput.errors | firstKey) === 'required' || (confirmedNewPasswordInput.errors | firstKey) === 'mustMatch')}"
        >
          <div
            *ngIf="changeExpiredPasswordForm.submitted && confirmedNewPasswordInput.invalid &&
    (confirmedNewPasswordInput.errors | firstKey) === 'required'"
            class="error-message"
            [innerHTML]="referenceDataConstants.ERROR_MESSAGE_ME000 | localizeErrorMessage : 'RetypedNewPassword'"
          ></div>

          <div
            *ngIf="changeExpiredPasswordForm.submitted && confirmedNewPasswordInput.invalid &&
  (confirmedNewPasswordInput.errors | firstKey) === 'mustMatch'"
            class="error-message"
            [innerHTML]="referenceDataConstants.ERROR_MESSAGE_EQ000 | localizeErrorMessage: 'RetypedNewPassword'"
          ></div>

          <boi-text-input
            class="field-input-full-width field-text-center"
            [cssClasses]="'label-top label-weight-bold'"
            [required]="true"
            name="confirmedNewPassword"
            #confirmedNewPasswordInput="ngModel"
            [(ngModel)]="resetPasswordDto.ConfirmedNewPassword"
            [labelName]="referenceDataLabels.UserResetPasswordRepeatNew"
            [canShowPassword]="true"
            [boiMustMatch]="resetPasswordDto.NewPassword"
            [type]="'password'"
          >
          </boi-text-input>
        </div>

        <div class="align-items-center d-flex flex-column my-30 w-100">
          <button
            class="vo-primary-button-1 mb-30 w-100"
            (click)="changeExpiredPassword(changeExpiredPasswordForm)"
            [innerHTML]="referenceDataLabels.UserResetPasswordSave | localizeLabel"
          ></button>
          <a class="vo-link" (click)="goBack()" [innerHTML]="referenceDataLabels.BackButtonText | localizeLabel"> </a>
        </div>
      </form>
    </ng-container>

    <ng-container *ngIf="currentStep === formStep.OtpCode">
      <form #sendOTPForm="ngForm" (ngSubmit)="validateOtpCode(sendOTPForm)">
        <div
          *ngIf="hasExceededMaximumOtpSendLimit && (hasUserExceededMaximumOtpValidation || !hasAnOtpCodeActive); else isValidationFormDisplayed"
          class="vo-info-box--danger-top mb-30 w-100"
          [innerHTML]="referenceDataLabels.VerificationCodeHasExceededMaximumOtpSendLimit | localizeLabel | toTrustedHtml"
        ></div>

        <ng-template #isValidationFormDisplayed>
          <ng-container *ngIf="!isOtpSend">
            <div
              class="vo-heading-bold-24 mb-30 text-center mt-60"
              [innerHTML]="referenceDataLabels.VerificationCodeTitle | localizeLabel | toTrustedHtml"
            ></div>

            <div>
              <div class="vo-body-regular-14 text-center mt-30">
                {{ referenceDataLabels.VerificationCodeInfoSend | localizeLabel }} {{ maskedPhoneNumber }}
              </div>

              <button
                class="vo-primary-button-1 w-100 mt-20"
                (click)="sendCode()"
                [innerHTML]="referenceDataLabels.VerificationCodeSendButton | localizeLabel"
              ></button>
            </div>
          </ng-container>

          <ng-container *ngIf="isOtpSend">
            <div
              *ngIf="isOtpInvalid && !hasUserExceededMaximumOtpValidation && hasAnOtpCodeActive"
              class="vo-info-box--danger-top mb-30 w-100"
              [innerHTML]="referenceDataLabels.VerificationCodeInvalidOtpInfo | localizeLabel | toTrustedHtml"
            ></div>

            <div
              *ngIf="hasUserExceededMaximumOtpValidation && hasAnOtpCodeActive && !hasOtpNotBeenSent"
              class="vo-info-box--danger-top mb-30 w-100"
              [innerHTML]="referenceDataLabels.VerificationCodeHasExceededMaximumOtpValidation | localizeLabel | toTrustedHtml"
            ></div>

            <div
              *ngIf="!hasAnOtpCodeActive && !hasOtpNotBeenSent"
              class="vo-info-box--danger-top mb-30 w-100"
              [innerHTML]="referenceDataLabels.VerificationCodeHasExpired | localizeLabel | toTrustedHtml"
            ></div>

            <div
              [innerHtml]="referenceDataLabels.ExceededMaximumOtpSendLimitErrorMessage | localizeLabel | toTrustedHtml"
              *ngIf="hasExceededMaximumOtpSendLimit"
              class="vo-info-box--danger-top mb-30 w-100"
            ></div>

            <div
              [innerHtml]="referenceDataLabels.OtpHasNotBeenSentErrorMessage | localizeLabel | toTrustedHtml"
              *ngIf="hasOtpNotBeenSent && !hasUserExceededMaximumOtpValidation"
              class="vo-info-box--danger-top mb-30 w-100"
            ></div>

            <div
              class="vo-heading-bold-24 mb-30 text-center"
              [innerHTML]="referenceDataLabels.VerificationCodeTitle | localizeLabel | toTrustedHtml"
            ></div>

            <div class="vo-body-regular-14 text-center my-30">
              {{ referenceDataLabels.VerificationCodeInfoSent | localizeLabel }} {{ maskedPhoneNumber }}
            </div>

            <boi-text-input
              type="text"
              [labelName]="referenceDataLabels.VerificationCodeEnterInputLabel"
              [(ngModel)]="otpCode"
              [required]="true"
              cssClasses="label-top label-weight-bold"
              class="field-input-full-width mb-10 mt-0 field-text-center"
            >
            </boi-text-input>

            <button
              type="submit"
              [disabled]="(blockResend && hasUserExceededMaximumOtpValidation) || (blockResend && !hasAnOtpCodeActive) || hasUserExceededMaximumOtpValidation"
              class="vo-primary-button-1 w-100 mt-30"
              [innerHTML]="referenceDataLabels.Continue | localizeLabel"
            ></button>

            <button
              [disabled]="hasExceededMaximumOtpSendLimit || blockResend"
              class="vo-primary-button-2 w-100 mt-20"
              (click)="sendCode()"
              [innerHTML]="referenceDataLabels.VerificationCodeReSendButton | localizeLabel"
            ></button>
          </ng-container>
        </ng-template>

        <a
          class="vo-link d-flex justify-content-center mt-30"
          (click)="goBack()"
          [innerHTML]="referenceDataLabels.BackToLoginButton | localizeLabel"
        >
        </a>
      </form>
    </ng-container>
  </div>
</div>
